import React from 'react';
import styles from './ConfirmationThankYou.module.scss';
import { ReactComponent as LogoImage } from '../../../images/logo-full.svg';
import { useNavigate } from 'react-router-dom';
import AuthFooter from '../../../components/auth/AuthFooter';

const ConfirmationThankYou: React.FC = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate('/');
  };

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <a href="https://jobbeast.org" target="_blank" rel="noopener noreferrer">
          <LogoImage className={styles.logo} />
        </a>
      </div>
      <div className={styles.content}>
        <h1>Thank You for Verifying Your Email!</h1>
        <p>
          Your account has been successfully verified. You can now access all the features of our app.
        </p>
        <button onClick={handleContinue} className={styles.button}>
          Continue to Main Page
        </button>
      </div>
      <AuthFooter />
    </div>
  );
};

export default ConfirmationThankYou;